module["exports"] = [
  "中国"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_CN/address/default_country.js
// module id = 1806
// module chunks = 0